/* =====================================================================
   Septenz Startseite v2 – Animationen & Interaktion
   Wort-Animation, Reveal, 3D-Shop-Stapel, Laufbänder, Zähler,
   Galerie + Großansicht, Paket-Finder, Nischen-Links, Kostenrechner, Ablauf
   Texte: deutsch als Standard, andere Sprachen über window.spzT (snippets/spz-i18n.liquid)
   ===================================================================== */
(function () {
  'use strict';
  if (window.__spz2h) return; window.__spz2h = true;
  var d = document, root = d.documentElement;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia && matchMedia('(pointer: fine)').matches;
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || d).querySelectorAll(s)); };
  var eur = function (v) { return T('money', '{a} €', { a: v.toLocaleString('de-DE', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }) }); };
  /* Text in der Shop-Sprache: Standard ist der deutsche Text, {x} wird ersetzt */
  var T = function (k, s, o) { var m = window.spzT; if (m && m[k] != null) s = m[k]; if (o) for (var x in o) s = s.split('{' + x + '}').join(o[x]); return s; };
  var withParam = function (url, k, v) { if (!v) return url; var u = new URL(url, location.origin); u.searchParams.set(k, v); return u.pathname + u.search; };
  if (reduce) root.classList.remove('spz2h-js');

  /* ---------- Scroll-Schleife ---------- */
  var fns = [], ticking = false;
  var onScroll = function (fn) { fns.push(fn); fn(); };
  addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(function () { ticking = false; fns.forEach(function (f) { f(); }); }); } }, { passive: true });
  addEventListener('resize', function () { fns.forEach(function (f) { f(); }); });

  /* ---------- Wörter & Reveal ---------- */
  function split(el) {
    var i = 0;
    var walk = function (node) {
      [].slice.call(node.childNodes).forEach(function (ch) {
        if (ch.nodeType === 3) {
          var frag = d.createDocumentFragment();
          ch.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(d.createTextNode(' ')); return; }
            var w = d.createElement('span'); w.className = 'w';
            var s = d.createElement('span'); s.textContent = part; s.style.setProperty('--i', i++);
            w.appendChild(s); frag.appendChild(w);
          });
          node.replaceChild(frag, ch);
        } else if (ch.nodeType === 1 && ch.tagName !== 'BR' && ch.tagName.toLowerCase() !== 'svg') walk(ch);
      });
    };
    walk(el); el.setAttribute('data-split-done', '');
  }
  var io = (reduce || !('IntersectionObserver' in window)) ? null :
    new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } }); }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
  function reveal() {
    $$('.spz2h h2:not([data-nosplit])').forEach(function (h) { if (!h.hasAttribute('data-split')) h.setAttribute('data-split', ''); });
    $$('.spz2h [data-split]:not([data-split-done])').forEach(function (el) { if (el.getAttribute('data-split') !== 'load') split(el); });
    $$('.spz2h-r').forEach(function (el) {
      if (el.style.getPropertyValue('--d')) return;
      var sib = [].slice.call(el.parentElement.children).filter(function (c) { return c.classList.contains('spz2h-r'); });
      if (sib.length > 1) el.style.setProperty('--d', Math.min(sib.indexOf(el), 6) * 90 + 'ms');
    });
    var els = $$('.spz2h-r:not(.in), .spz2h [data-split]:not(.in):not([data-split="load"])');
    if (!io) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    els.forEach(function (e) { io.observe(e); });
  }
  function intro() {
    $$('.spz2h [data-split="load"]:not([data-split-done])').forEach(split);
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      root.classList.add('spz2h-ready');
      $$('.spz2h [data-split="load"]').forEach(function (el) { el.classList.add('in'); });
    }); });
  }
  function progress() {
    if (reduce || !$('.spz2h')) return;
    var bar = d.createElement('div'); bar.className = 'spz2h-progress'; bar.setAttribute('aria-hidden', 'true'); d.body.appendChild(bar);
    onScroll(function () { var h = root.scrollHeight - innerHeight; bar.style.transform = 'scaleX(' + (h > 0 ? Math.min(1, scrollY / h) : 0) + ')'; });
  }

  /* ---------- Zahlen ---------- */
  function counters() {
    $$('[data-count]').forEach(function (el) {
      if (el.__i) return; el.__i = 1;
      var raw = el.getAttribute('data-count'), to = parseFloat(raw.replace(',', '.')), dec = (raw.split(/[.,]/)[1] || '').length;
      var fmt = function (v) { return (el.getAttribute('data-prefix') || '') + v.toLocaleString(T('num_locale', 'de-DE'), { minimumFractionDigits: dec, maximumFractionDigits: dec }) + (el.getAttribute('data-suffix') || ''); };
      if (!io || isNaN(to)) return;
      var run = function () { var t0 = performance.now(); var step = function (t) { var p = Math.min(1, (t - t0) / 1600), e = 1 - Math.pow(1 - p, 4); el.textContent = fmt(to * e); if (p < 1) requestAnimationFrame(step); }; requestAnimationFrame(step); };
      var o = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { run(); o.disconnect(); } }, { threshold: 0.6 });
      o.observe(el);
    });
  }

  /* ---------- Laufbänder ---------- */
  function loops() {
    $$('[data-loop]').forEach(function (t) {
      if (t.__loop) return; t.__loop = 1;
      var n = t.children.length;
      t.insertAdjacentHTML('beforeend', t.innerHTML);
      [].slice.call(t.children).slice(n).forEach(function (c) { c.setAttribute('aria-hidden', 'true'); $$('a,button', c).forEach(function (x) { x.tabIndex = -1; }); if (c.matches('a,button')) c.tabIndex = -1; });
    });
  }

  /* ---------- Hero: 3D-Stapel echter Shops ---------- */
  function hero() {
    $$('[data-hero]').forEach(function (st) {
      if (st.__i) return; st.__i = 1;
      var cards = $$('.spz2h-dcard', st), chips = $$('[data-chip]', st), deck = $('[data-deck]', st);
      if (!cards.length) return;
      var ms = +st.getAttribute('data-ms') || 4200, cur = 0, timer;
      st.style.setProperty('--ms', ms + 'ms');
      var wake = function (c) {
        var im = $('img[data-later]', c); if (!im) return;
        im.removeAttribute('data-later');
        if (im.getAttribute('data-srcset')) im.srcset = im.getAttribute('data-srcset');
        if (im.getAttribute('data-src')) im.src = im.getAttribute('data-src');
      };
      var wakeAll = function () { setTimeout(function () { cards.forEach(wake); }, 300); };
      if (d.readyState === 'complete') wakeAll(); else addEventListener('load', wakeAll);
      var paint = function (prev) {
        var L = cards.length;
        cards.forEach(function (c, i) { if ((i - cur + L) % L <= 2) wake(c); });
        cards.forEach(function (c, i) { var off = (i - cur + L) % L; c.setAttribute('data-pos', i === prev ? 'out' : off === 0 ? '0' : off === 1 ? '1' : off === 2 ? '2' : 'hide'); });
        if (prev != null) setTimeout(function () { if (cards[prev].getAttribute('data-pos') !== 'out') return; var off = (prev - cur + L) % L; cards[prev].setAttribute('data-pos', off === 1 ? '1' : off === 2 ? '2' : 'hide'); }, 900);
        chips.forEach(function (b, j) { b.setAttribute('aria-pressed', String(j === cur)); var bar = $('.bar', b); if (bar) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; } });
        var c = cards[cur];
        var n = $('[data-fcname]', st), t = $('[data-fcniche]', st);
        if (n) n.textContent = c.getAttribute('data-name') || '';
        if (t) t.textContent = T('real_shop_niche', 'Echter Septenz-Shop · {niche}', { niche: c.getAttribute('data-niche') || '' });
      };
      var go = function (i) { var prev = cur === i ? null : cur; cur = (i + cards.length) % cards.length; paint(prev); };
      var stop = function () { clearInterval(timer); st.classList.remove('auto'); };
      var play = function () { clearInterval(timer); if (reduce) { st.classList.remove('auto'); return; } st.classList.add('auto'); timer = setInterval(function () { go(cur + 1); }, ms); };
      chips.forEach(function (b, j) { b.addEventListener('click', function () { stop(); go(j); }); });
      var open = function () { var c = cards[cur]; var href = c.getAttribute('data-href'); if (href) location.href = href; };
      if (deck) { deck.addEventListener('click', open); deck.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } }); }
      d.addEventListener('visibilitychange', function () { if (d.hidden) clearInterval(timer); else if (st.classList.contains('auto')) play(); });
      paint(null); play();
    });
    $$('[data-eta]').forEach(function (el) {
      var h = +el.getAttribute('data-eta') || 48;
      el.textContent = T('eta_on', 'am {date}', { date: new Date(Date.now() + h * 36e5).toLocaleDateString(T('date_locale', 'de-DE'), { weekday: 'long', day: 'numeric', month: 'numeric' }) });
    });
  }

  /* ---------- Galerie + Großansicht ---------- */
  function gallery() {
    $$('[data-gallery]').forEach(function (sec) {
      if (sec.__i) return; sec.__i = 1;
      var cards = $$('[data-card]', sec), filter = $('[data-filter]', sec), lb = $('[data-lb]', sec);
      if (!cards.length) return;
      if (filter) {
        var counts = {}, order = [];
        cards.forEach(function (c) { var n = c.getAttribute('data-n'); if (!n) return; if (!counts[n]) { counts[n] = 0; order.push(n); } counts[n]++; });
        filter.innerHTML = '<button type="button" data-f="" aria-pressed="true">' + T('all', 'Alle') + ' <small>' + cards.length + '</small></button>' +
          order.map(function (n) { return '<button type="button" data-f="' + n.replace(/"/g, '&quot;') + '" aria-pressed="false">' + n + ' <small>' + counts[n] + '</small></button>'; }).join('');
        $$('button', filter).forEach(function (b) {
          b.addEventListener('click', function () {
            $$('button', filter).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
            var f = b.getAttribute('data-f');
            cards.forEach(function (c) { c.hidden = !!f && c.getAttribute('data-n') !== f; if (!c.hidden) c.classList.add('in'); });
          });
        });
      }
      if (!lb) return;
      var idx = 0, last = null;
      var render = function () {
        var c = cards[idx];
        $('[data-lb-img]', lb).src = c.getAttribute('data-lg'); $('[data-lb-img]', lb).alt = c.getAttribute('data-name');
        $('[data-lb-niche]', lb).textContent = c.getAttribute('data-n');
        $('[data-lb-title]', lb).textContent = c.getAttribute('data-name');
        $('[data-lb-text]', lb).textContent = T('lb_text', 'Ein echter Septenz-Shop für die Nische {niche}. So oder ähnlich sieht dein Shop aus, mit Produkten und Design passend zu deiner Nische.', { niche: c.getAttribute('data-n') });
        var cta = $('[data-lb-cta]', lb); cta.href = c.getAttribute('data-href'); $('span', cta).textContent = T('lb_cta', '{niche}-Shop starten', { niche: c.getAttribute('data-n') });
        $('[data-lb-count]', lb).textContent = T('lb_count', 'Shop {i} von {n}', { i: idx + 1, n: cards.length });
      };
      var open = function (i) { last = d.activeElement; idx = i; render(); lb.hidden = false; root.style.overflow = 'hidden'; var x = $('[data-lb-close].spz2h-lb-x', lb); if (x) x.focus(); };
      var close = function () { if (lb.hidden) return; lb.hidden = true; root.style.overflow = ''; if (last && last.focus) last.focus(); };
      var step = function (s) { idx = (idx + s + cards.length) % cards.length; render(); };
      cards.forEach(function (c, i) { c.addEventListener('click', function () { open(i); }); });
      $$('[data-belt-i]', sec).forEach(function (b) { b.addEventListener('click', function () { open(+b.getAttribute('data-belt-i')); }); });
      $('[data-lb-prev]', lb).addEventListener('click', function () { step(-1); });
      $('[data-lb-next]', lb).addEventListener('click', function () { step(1); });
      $$('[data-lb-close]', lb).forEach(function (x) { x.addEventListener('click', close); });
      d.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowLeft') step(-1);
        if (e.key === 'ArrowRight') step(1);
        if (e.key === 'Tab') { var f = $$('a,button', lb).filter(function (x) { return x.offsetParent; }); var a = f[0], z = f[f.length - 1]; if (e.shiftKey && d.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && d.activeElement === z) { e.preventDefault(); a.focus(); } }
      });
    });
  }

  /* ---------- Paket-Finder ---------- */
  function finder() {
    $$('[data-finder]').forEach(function (F) {
      if (F.__i) return; F.__i = 1;
      var R = JSON.parse(($('[data-recs]', F) || {}).textContent || '[]');
      var ans = [null, null, null], res = $('[data-res]', F);
      $$('[data-q]', F).forEach(function (q) {
        var qi = +q.getAttribute('data-q');
        $$('button', q).forEach(function (b) { b.addEventListener('click', function () { $$('button', q).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); }); ans[qi] = +b.getAttribute('data-v'); show(); }); });
      });
      function show() {
        var open = ans.filter(function (a) { return a === null; }).length;
        if (open) { res.className = 'spz2h-res empty'; res.textContent = open > 1 ? T('finder_left_many', 'Noch {n} Fragen, dann siehst du deine Empfehlung.', { n: open }) : T('finder_left_one', 'Noch {n} Frage, dann siehst du deine Empfehlung.', { n: open }); return; }
        var e = ans[0], g = ans[1], s = ans[2], i;
        if (g === 2 && (s === 2 || e === 2)) i = 4; else if (s === 2) i = 3; else { var sum = e + g + s; i = sum <= 1 ? 0 : sum <= 3 ? 1 : 2; }
        var r = R[Math.min(i, R.length - 1)]; if (!r) return;
        res.className = 'spz2h-res';
        res.innerHTML = '<div><div class="l">' + T('finder_rec', 'Unsere Empfehlung für dich') + '</div><div class="n">' + r.n + ' · ' + r.p + '</div><div class="t">' + r.t + '</div></div><a class="spz2h-btn" href="' + r.u + '">' + T('finder_cta', 'Zum Paket') + ' <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a>';
      }
    });
  }

  /* ---------- Pakete: Nische in die Links übernehmen ---------- */
  function pricing() {
    $$('[data-pricing]').forEach(function (P) {
      if (P.__i) return; P.__i = 1;
      var pick = $('[data-npick]', P), links = $$('[data-plink]', P), note = $('[data-nnote]', P);
      if (!pick) return;
      links.forEach(function (a) { a.__base = a.getAttribute('href'); a.__lbl = a.getAttribute('data-plabel'); });
      $$('button', pick).forEach(function (b) {
        b.addEventListener('click', function () {
          var on = b.getAttribute('aria-pressed') !== 'true';
          $$('button', pick).forEach(function (x) { x.setAttribute('aria-pressed', String(on && x === b)); });
          var n = on ? b.getAttribute('data-n') : '', label = on ? b.textContent.trim() : '';
          links.forEach(function (a) {
            a.setAttribute('href', withParam(a.__base, 'nische', n));
            var t = $('[data-ptext]', a); if (t && a.__lbl) t.textContent = label ? T('choose_for', '{pkg} für {niche} wählen', { pkg: a.__lbl, niche: label }) : T('choose', '{pkg} wählen', { pkg: a.__lbl });
          });
          if (note) note.innerHTML = label ? T('niche_note', 'Dein Shop wird für <b>{niche}</b> gebaut. Du kannst die Nische beim Bestellen noch ändern.', { niche: label }) : '';
        });
      });
    });
  }

  /* ---------- Kostenrechner ---------- */
  function calc() {
    $$('[data-calc]').forEach(function (C) {
      if (C.__i) return; C.__i = 1;
      var cfg = JSON.parse(($('[data-cfg]', C) || {}).textContent || '{}');
      var seg = $$('[data-seg] button', C), ad = $('[data-ad]', C);
      if (!seg.length) return;
      var upd = function () {
        var sel = seg.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] || seg[0];
        var plan = +sel.getAttribute('data-p'), name = sel.getAttribute('data-name');
        var extras = 0; $$('[data-x]', C).forEach(function (x) { if (x.checked) extras += +x.getAttribute('data-x'); });
        var dom = $('[data-dom]', C), domV = dom && dom.checked ? +cfg.domain : 0;
        var adV = ad ? +ad.value : 0;
        var set = function (s, v) { var el = $(s, C); if (el) el.textContent = v; };
        set('[data-o-name]', name); set('[data-o-plan]', eur(plan)); set('[data-o-extras]', eur(extras)); set('[data-o-ad]', eur(adV)); set('[data-ad-val]', eur(adV));
        var le = $('[data-l-extras]', C); if (le) le.hidden = !extras;
        var ld = $('[data-l-dom]', C); if (ld) ld.hidden = !domV;
        set('[data-o-total]', eur(Math.round((plan + extras + domV + adV + (+cfg.shopify || 0)) * 100) / 100));
        set('[data-o-us]', eur(Math.round((plan + extras) * 100) / 100));
        var cta = $('[data-o-cta]', C); if (cta) { cta.setAttribute('href', sel.getAttribute('data-u')); var sp = $('span', cta); if (sp) sp.textContent = T('choose', '{pkg} wählen', { pkg: name }); }
      };
      seg.forEach(function (b) { b.addEventListener('click', function () { seg.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); }); upd(); }); });
      $$('input', C).forEach(function (i) { i.addEventListener('input', upd); i.addEventListener('change', upd); });
      upd();
    });
  }

  /* ---------- Ablauf ---------- */
  function process() {
    $$('[data-process]').forEach(function (box) {
      if (box.__i) return; box.__i = 1;
      var steps = $$('.spz2h-pstep', box), panels = $$('[data-panel]', box), big = $('[data-big]', box);
      if (!steps.length) return;
      var ms = +box.getAttribute('data-ms') || 5500; box.style.setProperty('--ms', ms + 'ms');
      var cur = 0, timer, inView = false;
      var set = function (i) {
        cur = i;
        steps.forEach(function (s, j) { s.classList.remove('on'); void s.offsetWidth; s.classList.toggle('on', j === i); s.setAttribute('aria-selected', String(j === i)); });
        panels.forEach(function (p, j) { p.hidden = j !== i; if (j === i) { p.classList.remove('spz2h-swap'); void p.offsetWidth; p.classList.add('spz2h-swap'); } });
        if (big) { big.textContent = String(i + 1).padStart(2, '0'); big.classList.remove('spz2h-swap'); void big.offsetWidth; big.classList.add('spz2h-swap'); }
      };
      var play = function () { clearInterval(timer); if (!reduce && inView) timer = setInterval(function () { set((cur + 1) % steps.length); }, ms); };
      steps.forEach(function (s, i) { s.addEventListener('click', function () { set(i); play(); }); });
      box.addEventListener('mouseenter', function () { clearInterval(timer); box.classList.add('paused'); });
      box.addEventListener('mouseleave', function () { box.classList.remove('paused'); set(cur); play(); });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { inView = en[0].isIntersecting; if (inView) { set(cur); play(); } else clearInterval(timer); }, { threshold: 0.35 }).observe(box);
      set(0);
    });
  }

  /* ---------- Tilt ---------- */
  function tilt() {
    if (!fine || reduce) return;
    $$('[data-tilt]').forEach(function (el) {
      el.addEventListener('pointermove', function (e) { var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5; el.style.transform = 'perspective(900px) rotateX(' + (-y * 5).toFixed(2) + 'deg) rotateY(' + (x * 6).toFixed(2) + 'deg) translateY(-4px)'; });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
  }

  function start() { intro(); progress(); loops(); hero(); gallery(); finder(); pricing(); calc(); process(); reveal(); counters(); tilt(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
  d.addEventListener('shopify:section:load', function () { loops(); hero(); gallery(); finder(); pricing(); calc(); process(); reveal(); counters(); });
})();
